import { render, staticRenderFns } from "./PaginationTabs.vue?vue&type=template&id=60c567c1&scoped=true&"
import script from "./PaginationTabs.vue?vue&type=script&lang=ts&"
export * from "./PaginationTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c567c1",
  null
  
)

export default component.exports